import { render, staticRenderFns } from "./changetestphone.vue?vue&type=template&id=a6409d1e&scoped=true"
import script from "./changetestphone.vue?vue&type=script&lang=js"
export * from "./changetestphone.vue?vue&type=script&lang=js"
import style0 from "./changetestphone.vue?vue&type=style&index=0&id=a6409d1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6409d1e",
  null
  
)

export default component.exports